export default __webpack_public_path__ + "static/media/water-heater.b10e35ef.svg";